<template>
  <div>
    
    <!-- v-model="$data['taskModel'][field.field]" -->
    <RadioGroup v-model="idlvl1"  @change="radioChanged" >
      <Radio v-for="(l,li) in filteredRoot" :label="l.id" :key="l.li">
        <span>{{ l.title }}</span>
      </Radio>
    </RadioGroup>
    
    <!-- <div v-if="selcur.code!=undefined && (selcur.code=='foreign' || selcur.code=='other')" class="alert alert-warning">
      Мэргэжлийн сэтгүүл гадаадад хэвлүүлсэн бол сэтгүүлийн холбоосыг оруулна уу
    </div> -->

    <div class="alert alert-secondary" v-if="idlvl3!=null">
      <b class="lh-1">{{ seljurRoot.title }}</b>
      <ul class="mg-l-20 mg-b-0">
        <li class="lh-1 mg-b-5">Сэтгүүлийн нэр: {{ seljur.title }}</li>
        <li class="lh-1 mg-b-5">Байгууллага: {{ seljur.desc }}</li>
        <li class="lh-1">Дугаар: {{ seljur.code }}</li>
      </ul>
    </div>

    <div v-if="prntId==346568" class="alert alert-warning" style="line-height: 1.5">
      Докторын зэрэг хамгаалуулах зөвлөлийн дүрмийн 2.9.1.энэхүү дүрмийн 1.5.1-д заасан чиглэлд хамаарах Зөвлөлийн гишүүн сүүлийн есөн жилд олон улсын шинжлэх ухааны мэдээллийн санд бүртгэлтэй мэргэжлийн сэтгүүл (Web of Science, Scopus)-д нэгдүгээр зохиогч, эсвэл холбоо баригчаар эрдэм шинжилгээний өгүүлэл хэвлүүлсэн байх;
    </div>
    <div v-else-if="prntId==346604" class="alert alert-warning" style="line-height: 1.5">
      Докторын зэрэг хамгаалуулах зөвлөлийн дүрмийн 2.9.2.энэхүү дүрмийн 1.5.2-т заасан чиглэлд хамаарах Зөвлөлийн гишүүн тухайн мэргэжлийн чиглэлээр хянан магадалгаа хийгддэг олон улсын мэдээллийн санд бүртгэлтэй сэтгүүлд хоёроос доошгүй эрдэм шинжилгээний өгүүллийг нэгдүгээр зохиогч, эсвэл холбоо баригчаар, үүнээс нэг өгүүллийг сүүлийн долоон жилд хэвлүүлсэн байх;
    </div>
    <div v-else-if="prntId==346616" class="alert alert-warning" style="line-height: 1.5">
      Докторын зэрэг хамгаалуулах зөвлөлийн дүрмийн 2.9.3.энэхүү дүрмийн 1.5.3-т заасан чиглэлд хамаарах Зөвлөлийн гишүүн хянан магадалгаа хийгддэг дотоодын болон олон улсын мэргэжлийн сэтгүүлд нэгдүгээр зохиогч, эсвэл холбоо баригчаар хоёроос доошгүй эрдэм шинжилгээний өгүүллийг сүүлийн таван жилд хэвлүүлсэн байх;
    </div>

    <!-- <div class="d-flex">
      <div :class="`wd-${disableAdd ? '100p' : '80p'}`">
        <Cascader
          :placeholder="placeholder"
          filterable
          :options="list"
          :props="{ checkStrictly: checkStrictly }"
          v-model="cascaderSelected"
          @change="cascaderOnChange"
          :disabled="disabled"
          clearable
          style="width:100%"
          :size="size"
        ></Cascader>
      </div>
    </div> -->
    <b-modal v-model="modalShow" hide-footer size="lg" centered scrollable title="Сэтгүүл сонгох">
      
      <div class="d-flex align-items-center mg-b-20">
        <div class="wd-150 mg-r-10">Сонгоно уу</div>
        <Select v-model="idlvl2" class="wd-100p">
          <Option :value="ss.id" :label="ss.title" v-for="(ss,si) in listFlat.filter(x=>x.parentId == selcur.id)"></Option>
        </Select>
      </div>

      <div class="d-flex mg-b-20">
        <div class="mg-r-10">
          <div class="text-muted">СЭТГҮҮЛИЙН НЭР</div>
          <input v-model="fltrModel.v1" class="form-control">
        </div>
        <div class="mg-r-10">
          <div class="text-muted">БАЙГУУЛЛАГА</div>
          <input v-model="fltrModel.v2" class="form-control">
        </div>
        <div class="mg-r-10">
          <div class="text-muted">Дугаар</div>
          <input v-model="fltrModel.v3" class="form-control">
        </div>
        <div class="d-flex align-items-center">
          <div class="mg-r-10"><a @click="fltr(false)" class="btn btn-xs btn-light">Хайх</a></div>
          <div><a @click="fltr(true)" class="btn btn-xs btn-light">Бүгд</a></div>
        </div>
      </div>

      <table class="wd-100p table-bordered table-striped">
        <thead>
          <tr>
            <th>Д/д</th>
            <th>СЭТГҮҮЛИЙН НЭР</th>
            <th>БАЙГУУЛЛАГА</th>
            <th>Дугаар</th>
            <th>-</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(sj,ji) in filteredList">
            <td class="wd-30 text-right pd-5">{{ ji+1 }}</td>
            <td class="pd-5">{{ sj.title }}</td>
            <td class="wd-30p pd-5">{{ sj.desc }}</td>
            <td class="wd-150 pd-5">{{ sj.code }}</td>
            <td class="pd-5">
              <a @click="journalSelected(sj)" role="button" href="javascript:void(0)" class="btn btn-primary btn-xs">Сонгох</a>
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>

<script>

import { getTypeTreeData } from "@/api/type";
import { request } from "@/api/all";
import { hasOneOf } from "@/libs/tools";
import "element-ui/lib/theme-chalk/index.css";
import {
  Select,
  Option,
  RadioGroup, Radio
} from "element-ui";

var LTT = require("list-to-tree");

export default {
  components: {
    RadioGroup, Radio,
    Select,
    Option,
    
  },
  name: "locTypeJournal",
  props: {
    id: {
      type: Number,
      default: () => 0
    },
    prms: {
      type: Object,
      default: () => {}
    },
    locTypekey: {
      type: String,
      default: () => ""
    },
    guid: {
      type: String,
      default: () => ""
    },
    getParentType: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    disableAdd: {
      type: Boolean,
      default: () => false
    },
    size: {
      type: String,
      default: () => "medium"
    },
    checkStrictly: {
      type: Boolean,
      default: () => false
    },
    withUserId: {
      type: String,
      default: () => ""
    },
    parentFilterable: {
      type: Boolean,
      default: () => false
    },
    parentId: {
      type: Number,
      default: () => 0
    },
    placeholder:{
      type: String,
      default: () => "Сонгоно уу"
    },
    // taskModel:{
    //   type: Object,
    //   default: () => {}
    // }
  },
  data() {
    return {
      prntId: null,
      fltrModel:{
        v1: '',
        v2: '',
        v3: '',
      },
      idlvl1: null,
      idlvl2: null,
      idlvl3: null,
      modalShow: false,
      selcur:{
        id: null
      },
      seljur:{

      },
      seljurRoot:{},
      list: [],
      listFlat: [],
      cascaderSelected: [],
      selectedTypeId: 0,
      selectedLabel: "",
      locTypeModel: {
        parentId: 0
      },
      editMode: false,
      postedId: 0,
      fileDialog: {
        modal: false,
        show: false,
        id: 0,
        blank: false,
        src: ""
      }
    };
  },
  mounted() {
    //console.log('this.prms', this.prms);
    if(this.prms.fillAfter!=undefined){
      request({
        api: { url: "task/taskInheritedDetail", method: "get" },
        params: { id: this.prms.fillAfter.organizationTaskId },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.befInit(res.data.task.locTypeId1);
        }
      });
    }else{
      this.befInit();
    }
  },
  computed: {
    filteredList(){
      // console.log('this.listFlat', this.listFlat);
      return this.listFlat.filter(x => 
        // x.title !=null &&
        // x.desc !=null &&
        // x.code !=null &&
        x.parentId === this.idlvl2
        // && x.title.toLowerCase().includes(this.fltrModel.v1.toLowerCase())
        // && x.desc.toLowerCase().includes(this.fltrModel.v2.toLowerCase())
        // && x.code.toLowerCase().includes(this.fltrModel.v3.toLowerCase())
      );
    },
    filteredRoot(){
      // return this.listFlat.filter(x=>x.parentId==0);
      let rv= JSON.parse(JSON.stringify(this.listFlat.filter(x=>x.parentId==0)));      
      // console.log('taskModel', this.taskModel.locTypeId1, this.parentId);
      if(this.prntId==346568) {
        // console.log('ene ajilsnu');
        //# 346568 => baigaliin uhaan
        // return this.listFlat.filter(x=>x.parentId==0 && x.id==347201)
        rv= rv.filter(x=>x.id==347201);
      } else if(this.prntId==346604) {
        //# 346568 => niigmiin uhaan
        rv= rv.filter(x=>x.id==347026);
      } else if(this.prntId==346616) {
        //# 346568 => humuunlegiin uhaan
        rv= rv.filter(x=>x.id==347026 || x.id==347025);
      }
      //this.listFlat.filter(x=>x.parentId==0);
      return rv;
    }
  },
  methods: {
    befInit(idd){
      let _prms={
        key: 'stf_doctorJournal'
      };
      if(idd!=undefined){
        _prms= { 
          id: idd,
          key: 'stf_doctorJournal'
        };
      }
      request({
        api: { url: "Type/GetInheritedDetail", method: "get" },
        params: _prms,
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          // console.log('res', );
          if(idd!=undefined){
            this.prntId= res.data.parentId;
          }

          this.init();
        }
      });
    },
    fltr(reset){
      if(reset){
        this.fltrModel.v1='';
        this.fltrModel.v2='';
        this.fltrModel.v3='';
      }
    },
    journalSelected(e){
      this.idlvl3= e.id;
      this.seljur=e;
      this.seljurRoot=this.listFlat.find(x => x.id === e.parentId);
      this.modalShow= false;
      this.$emit('input', e.id);
      this.$emit('on-journal-selcd', {locTypeId14: this.idlvl2, locTypeId15: this.idlvl1});
    },
    radioChanged(e) {
      const ftm = this.listFlat.find(x => x.id === e);
      // if(ftm && ftm.code=='mongol') {
      //   this.selcur=ftm;
      //   this.modalShow= true;
      //   this.$emit('input', null);
      // } else {
      //   this.$emit('input', ftm.id);
      //   this.selcur=ftm; 
      //   this.modalShow= false;
      // }

      if(ftm) {
        this.selcur=ftm;
        this.modalShow= true;
        this.$emit('input', null);
      }
      
      this.idlvl3=null
    },
    init() {
      getTypeTreeData({
        params: {
          key: this.locTypekey,
          getParentType: this.getParentType,
          userId: this.withUserId
        },
        store: this.$store
      }).then(res => {
        let dataTypes = res.data.types;
        this.listFlat = dataTypes;
        var ltt = new LTT(dataTypes, {
          key_id: "id",
          key_parent: "parentId",
          key_child: "children"
        });
        this.list = ltt.GetTree();
        //console.log('res.data.types', this.list);
        this.cascaderSelected = [];
        if (this.id > 0 || this.postedId > 0) {
          // console.log('this.id', this.id)
          const ftm = this.listFlat.find(x => x.id === this.id);
          if(ftm) {
            if(ftm.parentId>0){
              const ftm2 = this.listFlat.find(x => x.id === ftm.parentId);
              if(ftm2 && ftm2.parentId>0){
                const ftm1 = this.listFlat.find(x => x.id === ftm2.parentId);

                this.seljur=ftm;
                this.seljurRoot=ftm2;
                this.idlvl1=ftm1.id;
                this.idlvl3=ftm.id;
              }
            } else if(ftm.code!=undefined && (ftm.code=='foreign' || ftm.code=='other')){
              this.selcur=ftm;
              this.idlvl1= ftm.id;
            }
          }
        } 
      });
    },
  }
};
</script>
